module.exports = __webpack_public_path__ + "static/media/banner-thoi-trang.737eacba.jpg";